import * as actions from './actions';

import { catchError, filter, map, mergeMap, switchMap, withLatestFrom } from 'rxjs/operators';
import { concat, of } from 'rxjs';

import { Epic } from 'redux-observable';
import { RootAction } from 'store/actions';
import { RootDependencies } from 'store/dependencies';
import { RootState } from 'store/reducer';
import { isActionOf } from 'typesafe-actions';

export const getMineServiceBookingsEpic: Epic<RootAction, RootAction, RootState, RootDependencies> = (
  action$,
  state$,
  { apiClient },
) =>
  action$.pipe(
    filter(isActionOf(actions.getMineServiceBookings.request)),
    withLatestFrom(state$),
    switchMap(([{ payload }, state]) => {
      const { ownerType, ownerUuid, companyUuid, serviceUuid } = payload;

      return apiClient(state)
        .getMineServiceBookings(ownerType, ownerUuid, companyUuid, serviceUuid)
        .pipe(
          map(data => {
            return actions.getMineServiceBookings.success(data.response.data.bookings);
          }),
          catchError((error: Error) => of(actions.getMineServiceBookings.failure({ error }))),
        );
    }),
  );

// eslint-disable-next-line max-lines-per-function
export const patchServiceBookingStatusEpic: Epic<RootAction, RootAction, RootState, RootDependencies> = (
  action$,
  state$,
  { apiClient },
) =>
  action$.pipe(
    filter(isActionOf(actions.patchServiceBookingStatus.request)),
    withLatestFrom(state$),
    switchMap(([{ payload }, state]) => {
      const { ownerType, ownerUuid, companyUuid, serviceUuid, bookingId, status } = payload;

      return apiClient(state)
        .patchServiceBookingStatus(ownerType, ownerUuid, companyUuid, serviceUuid, bookingId, status)
        .pipe(
          mergeMap(() =>
            concat(
              of(actions.patchServiceBookingStatus.success()),
              of(
                actions.getMineServiceBookings.request({
                  ownerType,
                  ownerUuid,
                  companyUuid,
                  serviceUuid,
                }),
              ),
            ),
          ),
          catchError((error: Error) => of(actions.patchServiceBookingStatus.failure({ error }))),
        );
    }),
  );

// eslint-disable-next-line max-lines-per-function
export const createServiceBookingForWaitlistEpic: Epic<RootAction, RootAction, RootState, RootDependencies> = (
  action$,
  state$,
  { apiClient },
) =>
  action$.pipe(
    filter(isActionOf(actions.createServiceBookingForWaitlist.request)),
    withLatestFrom(state$),
    switchMap(([{ payload }, state]) => {
      const { ownerType, ownerUuid, companyUuid, serviceUuid, startAt, endAt, timeSlotId } = payload;

      return apiClient(state)
        .createServiceBookingForWaitlist(ownerType, ownerUuid, companyUuid, serviceUuid, startAt, endAt, timeSlotId)
        .pipe(
          map(xhrPayload => actions.createServiceBookingForWaitlist.success(xhrPayload.response.data.booking)),
          catchError((error: Error) => of(actions.createServiceBookingForWaitlist.failure({ error }))),
        );
    }),
  );
